export default __webpack_public_path__ + "static/media/2-1-2.26d4749d.webp";